import noop from 'utils/noop';

export const updateMParticleATTStatus = noop;
